module.exports = __webpack_public_path__ + "img/server-settings-button.8f18d9e7.svg";